// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "app/static/css/async/" + chunkId + "." + {"3236": "b3a34fa8","8367": "4dc68faa","859": "29dbaee5",}[chunkId] + ".css"
}